export { default } from "./testCardTitle";
